import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  wrapper: (props?: { isSolidCard?: boolean }) => ({
    display: "flex",
    flexDirection: "column",
    gap: 0,
    width: "100%",
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
    borderRadius: props?.isSolidCard ? spacing(0, 0, 1, 1) : spacing(1),
    marginTop: props?.isSolidCard ? 0 : spacing(1),
  }),
  infoBoxContainer: {
    position: "absolute",
    bottom: spacing(1.5),
    left: spacing(1.5),
    gap: spacing(1),
  },
  showName: {
    fontWeight: 500,
  },
  cardHeaderRoot: {
    overflow: "hidden",
  },
  cardHeaderContent: {
    overflow: "hidden",
  },
  largeText: {
    fontSize: "18px !important",
    fontWeight: 500,
  },
  twoLines: {
    WebkitLineClamp: 2,
  },
  detailsView: {
    padding: spacing(0.5, 1),
    width: "fit-content",
  },
  icon: {
    width: "12px",
    height: "12px",
    minWidth: "12px",
    marginRight: spacing(0.5),
  },
  detailsText: {
    color: grey[800],
    fontSize: 10,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  dateContainer: {
    minWidth: 175,
  },
  elipsisTwoLines: {
    display: "-webkit-box",
    overflow: "hidden",
    boxOrient: "vertical",
    "-webkit-box-orient": "vertical",
  },
}));

export default styles;
